import $ from 'jquery';
import util from 'util/Util.js'
import { View } from 'backbone';

import nameTemplate from 'properties/main/misc-form-report.ejs';


class MainMiscFormReportView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type="checkbox"]' : 'updateAttributes'
        };

        if (this.model.get('showError') === undefined) {
            this.model.set('showError', true, {silent: true});
        }

        if (this.model.get('newWindow') === undefined) {
            this.model.set('newWindow', true, {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( propName, propVal );
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let bShowError = util.isTrue(this.model.get('showError'));
        $(`input[name='showError']`).prop('checked', bShowError );

        let bNewWindow = util.isTrue(this.model.get('newWindow'));
        $(`input[name='newWindow']`).prop('checked', bNewWindow );

        this.delegateEvents();
        return this;
    }

}

export default MainMiscFormReportView;
